<!--  -->
<template>
    <div class="business-content-main outconfirm-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                    <el-button v-if="permission.applyPayment" size="small" type="warning" icon="el-icon-document-copy" class="search-btn" @click="batchComfirms()">{{
                        permission.applyPayment
                    }}</el-button>
                     <el-button size="small" type="warning" icon="el-icon-connection" class="search-btn" @click="entityRele()" v-if="permission.entityRele">{{
                    permission.entityRele
                }}</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="500"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    @sort-change="sortChange"
                    v-el-table-infinite-scroll="tableLoad"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <el-table-column show-overflow-tooltip width="190px" prop="OrderCode" label="单号"></el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="EntpCusName" label="供应商"></el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="OrderType" label="单据类型">
                        <template slot-scope="scope">
                            <i v-if="scope.row.OrderType == 0" class="c-active">采购付款</i>
                            <i v-else class="out-active">采购退货</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="SumPayable" label="订单总额">
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.SumPayable : -scope.row.SumPayable }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="TotalAmount" label="应付总额">
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="TotalAmount" label="本次申请">
                        <template slot-scope="scope">{{ scope.row.IsCanStateBack ? (scope.row.OrderType == 0 ? scope.row.TotalAmount : -scope.row.TotalAmount) : '-' }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80px" prop="Confirmer" label="确认人"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="160px" prop="ConfirmTime" label="确认时间"></el-table-column>
                    <el-table-column show-overflow-tooltip width="170px" label="申请结算单号">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.IsCanStateBack && scope.row.SettleCode" type="text" style="margin-left: 0; font-size: 13px" @click="gotoSettle(scope.row)">{{
                                scope.row.SettleCode
                            }}</el-button>
                            <span style="font-size: 12px; color: #999" v-else-if="scope.row.IsCanStateBack && !scope.row.SettleCode">数据异常</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100px">
                        <template slot-scope="scope">
                            <el-button
                                v-if="permission.applyPayment && !scope.row.IsCanStateBack"
                                :title="permission.applyPayment"
                                size="mini"
                                type="text"
                                @click="confirm(scope.row)"
                                >{{ permission.applyPayment }}</el-button
                            >
                            <el-tooltip class="item" effect="dark" content="需要状态回退请移至财务确认" placement="top-start">
                                <el-button icon="el-icon-warning-outline" title="状态回退" v-show="scope.row.IsCanStateBack" size="mini" type="text" style="color: #999"
                                    >状态回退</el-button
                                >
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="section-summary" v-if="isShowSummary">
                    <div>
                        <span>合计：{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
            <div class="section-title">
                <div>
                    <span>{{ !orderCode ? '' : '【' + orderCode + '】' }}订单明细</span>
                </div>
            </div>
            <div>
                <el-table
                    v-loading="loading"
                    class="detail-table"
                    :data="orderGoodsData"
                    style="width: 100%"
                    height="200px"
                    border=""
                    :header-cell-style="{ background: '#F2F6FC' }"
                >
                    <el-table-column prop="SortNum" label="序号" width="80"></el-table-column>
                    <el-table-column prop="APCode" label="汽配编码" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="GoodName" label="汽配名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="AutoSerise" label="车型" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Count" label="数量" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Count : -scope.row.Count }}</template>
                    </el-table-column>
                    <el-table-column prop="Unit" label="单位" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Price" label="采购价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Price.toFixed(2) : -scope.row.Price.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="PriceAmount" label="采购总价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{
                            scope.row.OrderType == 0 ? (scope.row.Count * scope.row.Price).toFixed(2) : -(scope.row.Count * scope.row.Price).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column prop="WarehousedCount" label="已入库数" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.WarehousedCount : -scope.row.WarehousedCount }}</template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="单据搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="供应商">
                            <el-select
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                allow-create
                                placeholder="供应商名称"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号">
                            <el-input
                                class="search-item"
                                style="width: 100%"
                                size="small"
                                v-model.trim="searchData.OrderCode"
                                v-filter-special-char="searchData.OrderCode"
                                placeholder="采购/退货单号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="申请状态">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.State">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单据类型">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.OrderType">
                                <el-option v-for="item in orderTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认人">
                            <el-select v-model="searchData.ConfirmerId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】付款申请' : '付款申请'"
                :visible.sync="isShowApplyDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -600px"
            >
                <div v-if="isShowApplyDialog" class="settle-op-content">
                    <ApplyPayment ref="applyPayment" @closeDialog="closeDialog" :ApplyList="multipleSelection"></ApplyPayment>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="实体关联" :visible.sync="showEntityVisible" width="600px">
            <div class="dialog-content" v-if="showEntityVisible">
                <entityReles EntpCusId="" @closeDialog="closeReleDialog"></entityReles>
            </div>
        </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ApplyPayment from '@/components/business/revenue_n/applyPayment';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import entityReles from '@/components/business/revenue/supEntityReles';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        entityReles,
        ApplyPayment
    },
    data() {
        return {
            summaryStr: '',
            orderCode: '',
            datetime1: [],
            loading: '',
            cusName: '',
            multipleSelection: null,
            dialogVisible: false,
            isShowApplyDialog: false,
            showEntityVisible: false,
            scanData: '',
            dataindex: 0,
            stopFresh: false,
            isShowSummary: false,
            searchData: {
                State: '',
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                page: 1,
                limit: this.commonPageSize
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderGoodsData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未申请', Value: '0' },
                { Text: '已申请', Value: '1' }
            ],
            orderTypeList: [
                { Text: '全部', Value: '' },
                { Text: '采购单', Value: '0' },
                { Text: '采购退货单', Value: '1' }
            ],
            SIdList: [],
            cusId: [],
            // 用于供应商名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('PaymentApplies');
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.showSearchDialog();
            }
            if (key === 13) {
                if (that.dialogVisible) that.handleSearch();
                else if (!that.isShowApplyDialog) {
                    if (that.currentRow && that.currentRow.RecordId && !that.currentRow.IsCanStateBack) that.confirm(that.currentRow);
                } else if (that.isShowApplyDialog) {
                    if (that.$refs.applyPayment) {
                        that.$refs.applyPayment.submitForm();
                    }
                }
            }
            if (key === 27) {
                if (that.dialogVisible) that.closeSearchDialog();
                else if (that.isShowApplyDialog) that.isShowApplyDialog = false;
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableDataLength - 1) {
                    if (that.currentRow && that.currentRow.OrderId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getOrderDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getOrderDetail();
                        }
                    });
                }
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        showSearchDialog() {
            this.initSearchSelectData();
            this.dialogVisible = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.getOrderDetail();
        },
        getOrderDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.loading = true;
                let url = '';
                if (item.OrderType == 0) url = '/api/EntpPurchaseOrder/GetEntpPurOrderOnlyGoodsListById';
                else url = '/api/EntpPurReturnOrder/GetEntpSupReturnOrderGoodsListById';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            OrderId: item.OrderId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderGoodsData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 供应商名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 供应商名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getSIdList();
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        // 勾选统计
        handleSelectionChange(val) {
            let cusId = [];
            this.multipleSelection = [];
            if (val.length > 0) {
                this.isShowSummary = true;
                let sa = 0; //采购总额
                let yshj = 0; //应收合计
                let sqhj = 0; //已申请合计
                let firstCus = '';
                for (let i = 0; i < val.length; i++) {
                    if (!val[i].IsCanStateBack) {
                        let oa = 0;
                        let ss = 0;
                        if (i == 0) {
                            firstCus = val[i].EntpCusId;
                            this.multipleSelection.push(val[i]);
                            cusId.push(val[i].EntpCusId);

                            oa = val[i].SumPayable;
                            ss = val[i].TotalAmount;
                        } else {
                            // if (firstCus !== val[i].EntpCusId) {
                            //     this.$refs.multipleTable.toggleRowSelection(val[i], false);
                            // }
                            let index = val[i].ReleCusIds.findIndex(i => firstCus == i);
                            if (index == -1) {
                                this.$refs.multipleTable.toggleRowSelection(val[i], false);
                            } else {
                                this.multipleSelection.push(val[i]);
                                cusId.push(val[i].EntpCusId);
                                oa = val[i].SumPayable;
                                ss = val[i].TotalAmount;
                            }
                        }

                        if (val[i].OrderType == 0) {
                            sa += oa;
                            yshj += ss;
                            if (val[i].IsCanStateBack) sqhj += ss;
                        } else {
                            sa -= oa;
                            yshj -= ss;
                            if (val[i].IsCanStateBack) sqhj -= ss;
                        }
                    }
                }

                this.summaryStr = '采购总额 = ' + sa.toFixed(2) + '；应付总额 = ' + yshj.toFixed(2) + '； 已申请总额 = ' + sqhj.toFixed(2);

                this.cusId = cusId;
            }
        },
        resetSearch() {
            this.searchData = {
                State: '',
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
            // this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (that.searchData.page == 1) {
                that.searchParams = { ...that.searchData };
            } else {
                that.searchParams.page = that.searchData.page;
            }
            that.stopFresh = true;

            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_N/GetSupOrdersAppliesList',
                    data: that.searchParams
                })
                .then(res => {
                    let data = res.data;
                    that.tableDataLength = res.count;
                    if (!data) {
                        if (that.searchData.page == 1) that.tableData = [];
                        return;
                    }

                    let list = [...that.tableData, ...data];
                    that.tableData = list;

                    that.stopFresh = data.length < that.searchData.limit;
                });
        },
        getSettleData(item) {
            return new Promise(resolve => {
                let that = this;
                that.$util
                    .axiosGet({
                        url: '/api/RevenueManagement_N/GetSettleCodeByRecordId',
                        data: { RecordId: item.RecordId },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) {
                            return;
                        }
                        resolve(data);
                    })
                    .catch(() => {});
            });
        },
        handleSearch() {
            this.tableData = [];
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        confirm(item) {
            let that = this;
            if (item.RecordId && !item.IsCanStateBack) {
                that.currentRow = item;
                that.multipleSelection = [];
                that.multipleSelection.push(item);
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowApplyDialog = true;
            } else {
                that.$util.warningMsg('申请数据异常，请刷新后重新操作');
            }
        },
        batchComfirms() {
            let that = this;
            if (that.multipleSelection.length > 0) {
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowApplyDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要申请的项');
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.RecordId;
        },
        closeDialog(recordIds) {
            this.isShowApplyDialog = false;
            let that = this;
            if (recordIds && recordIds.length > 0) {
                that.$refs.multipleTable.clearSelection();
                that.multipleSelection = null;
                that.tableData.forEach(item => {
                    for (let index = 0; index < recordIds.length; index++) {
                        let element = recordIds[index];
                        if (item.RecordId == element) {
                            that.getSettleData(item).then(res => {
                                if (res) {
                                    item.SettleCode = res.SettleCode;
                                    item.SettleId = res.Id;
                                }
                            });
                            item.IsCanStateBack = true;
                            return;
                        }
                    }
                });
            }
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (row.IsCanStateBack) return false;
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                if (this.cusId && this.cusId.length > 0) {
                    let findex = row.ReleCusIds.findIndex(i => this.cusId[0] == i);
                    // if (row.EntpCusId == this.cusId[0] && !row.IsCanStateBack) {
                    //     return true;
                    // } 
                    if (findex > -1 && !row.IsCanStateBack) {
                        return true;
                    }else {
                        return false;
                    }
                } else return true;
            } else return true; //可勾选
        },
        entityRele() {
            this.showEntityVisible = true;
        },
        closeReleDialog(){
            this.showEntityVisible = false;
        },
        gotoSettle(item) {
            if (item.SettleCode) {
                this.$router.push('/financeManage/settlements/suppliers?code=' + item.SettleCode);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#apply-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#apply-dialog::-webkit-scrollbar {
    display: none;
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    margin-bottom: 10px;
}
</style>
<style lang="less">
.outconfirm-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }
    .detail-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
    }
}
</style>
